<template>
  <HPopup class="h-supply-popup"
          ref="popup"
          v-show="visible">
    <div class="h-supply-body" v-if="itemInfo">
      <div class="popup-header">供应物品</div>

      <div class="supply-form h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <HArtifact :artifact="itemInfo"></HArtifact>
        <div class="supply-form-item sell-gold">
          <p class="ls-1">收购单价</p>
          <div>
            <input type="text" maxlength="9" spellcheck="false" readonly :value="itemInfo.gold">
          </div>
        </div>

        <div class="supply-form-item sell-amount">
          <p class="ls-1">供应数量</p>
          <div>
            <HInputNumber :min="1" :max="itemInfo.amount" v-model="amount"></HInputNumber>
          </div>
        </div>

        <div class="supply-form-item sell-cost">
          <p class="ls-1">总计可得金币</p>
          <div>
            <input type="text" spellcheck="false" readonly placeholder="0" :value="totalGold">
          </div>
        </div>

      </div>
    </div>

    <footer class="flex">
      <button v-click-sound-button
              class="h-btn normal btn-border"
              :disabled="submitDisable"
              @click="handleSubmit">
        供应
      </button>
      <button v-click-sound-button
              class="h-btn normal btn-border"
              @click="handleClose">
        取消
      </button>
    </footer>
  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index.vue'
  import HArtifact from '@/components/h-artifact/index'
  import HInputNumber from '@/components/h-input-number/index'

  import { mapGetters } from 'vuex'
  import API from '@js/api'

  export default {
    name: 'supply-popup',

    data () {
      return {
        amount: 1,
        submitLoading: false,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
      itemInfo: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    computed: {
      ...mapGetters('hero', [
        'gold'
      ]),

      totalGold () {
        return this.itemInfo.gold * this.amount || 0
      },

      submitDisable () {
        return !this.amount
      },
    },

    methods: {
      handleClose () {
        this.$emit('close')
      },

      handleFixAmount (e) {
        let v = e.target.value
        if (!/^\d+$/.test(v)) {
          v = +(v).replace(/[^\d]/g, '') || 0
        }
        this.amount = Math.max(+v, 0)
        this.$forceUpdate()
      },

      async handleSubmit () {
        try {
          if (this.submitLoading) {
            return
          }

          const confirm = await this.$confirm(`是否将物品【${this.itemInfo.nameCn}】出售给 ${this.itemInfo.nick}？`)
          if (!confirm) {
            return
          }

          this.submitLoading = true
          if (this.amount <= 0) {
            this.$message('未设置有效数量')
            return
          }

          if (this.amount > this.itemInfo.amount) {
            this.$message('数量超过最大值')
            return
          }

          await API.market.sellForRequestPurchase({
            id: this.itemInfo.id,
            amount: this.amount,
            cost: this.totalGold,
          })
          this.$emit('close')
          this.$emit('refresh')
          this.$message('交易成功')
        } catch (err) {
          this.$message(err)
        } finally {
          this.submitLoading = false
        }
      },

    },

    components: {
      HPopup,
      HArtifact,
      HInputNumber,
    }
  }
</script>

<style lang="stylus" scoped>
  .h-supply-body
    padding 10px
    width 500px

  footer
    margin-top 30px
    justify-content space-evenly

  .supply-header
    padding 10px 0
    line-height 16px
    font-size 12px
    letter-spacing 1px
    text-align center
    goldText1()

  .supply-form
    position relative
    display flex
    justify-content space-between
    margin 10px 0
    padding 3px

  .h-artifact
    flex-shrink 0

  .supply-form-item
    position relative
    display flex
    flex-direction column
    justify-content space-evenly
    width 120px
    flex-shrink 0
    padding 2px 5px
    font-size 12px
    text-align center
    goldText1()
    > p
      line-height 24px
    input
      height 24px
      border 1px solid rgba(255, 255, 255, 0.25)
      line-height 22px
      font-size 12px
      letter-spacing 1px
      border-radius 2px
      background-color rgba(0, 0, 0, 0.25)

</style>
